<template>
<div class="containers">
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol style="padding-right:4px" sm="2">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisiblePegawai()"
                            @blur="toggleCloseVisiblePegawai()"
                            v-model="queryPegawai"
                            v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                            @keydown.up="upPegawai"
                            @keydown.down="downPegawai"
                            @keydown.enter="selectItemPegawai"
                            placeholder="Pilih Pegawai"
                    >
                    <div class="popovers" v-show="visiblePegawai">
                        <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesPegawai"
                                :key="index"
                                :class="{ 'selected': (selectedPegawai == index)}"
                                @click="itemClickedPegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisibleUnit()"
                            @blur="toggleCloseVisibleUnit()"
                            v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                            v-model="queryUnit"
                            @keydown.up="upUnit"
                            @keydown.down="downUnit"
                            @keydown.enter="selectItemUnit"
                            placeholder="Pilih Unit Level"
                    >
                    <div class="popovers" v-show="visibleUnit">
                        <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesUnit"
                                :key="index"
                                :class="{ 'selected': (selectedUnit == index)}"
                                @click="itemClickedUnit(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisibleTipePegawai()"
                            @blur="toggleCloseVisibleTipePegawai()"
                            v-model="queryTipePegawai"
                            v-text="selectedItemTipePegawai ? selectedItemTipePegawai['text'] : ''"
                            @keydown.up="upTipePegawai"
                            @keydown.down="downTipePegawai"
                            @keydown.enter="selectItemTipePegawai"
                            placeholder="Pilih Tipe Pegawai"
                    >
                    <div class="popovers" v-show="visibleTipePegawai">
                        <div class="options" v-if="matchesTipePegawai.length != 0 && queryTipePegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesTipePegawai"
                                :key="index"
                                :class="{ 'selected': (selectedTipePegawai == index)}"
                                @click="itemClickedTipePegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesTipePegawai.length == 0 && queryTipePegawai.length == 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in dataTipePegawai"
                                :key="index"
                                :class="{ 'selected': (selectedKota == index)}"
                                @click="itemClickedTipePegawaiBefore(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesTipePegawai.length == 0 && queryTipePegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol sm="2" style="padding-right:4px;padding-left:4px">
                <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="dateStart" class="form-control"/>
            </CCol>
            <CCol sm="2" style="padding-right:4px;padding-left:4px">
                <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="dateEnd" class="form-control"/>
            </CCol>
            <CCol sm="1" style="padding-right:4px;padding-left:4px">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control" v-model="selectedStatus" placeholder="Status"></model-select>
            </CCol>
            <CCol style="padding-left:6px" sm="1">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6" style="float:left">
                <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:left"/>
                <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/>
            </CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
            </CCol>
        </CRow>
    </div>
    <Tables @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
</div>
</template>

<script>
import Tables from '../component/tableKedisiplinan'
import {DataApi} from "../service/DataApi";
import { ModelSelect } from 'vue-search-select'

const xlsx = require('json-as-xlsx')

export default {
    components: {
        ModelSelect,
        Tables
    },
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,

            // data search unit
            dataUnit: [],
            titleUnit:"Pilih Unit Level",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnits: '',

            // data search Tipe Pegawai
            dataTipePegawai: [],
            titleTipePegawai:"Pilih Tipe Pegawai",
            selectedItemTipePegawai: null,
            selectedTipePegawai: 0,
            queryTipePegawai: '',
            visibleTipePegawai: false,
            kodeTipePegawai: '',

            // datas
            refreshIcon: require('../assets/menu/icon_refresh.svg'),
            downloadIcon: require('../assets/menu/icon_download_excel.svg'),
            moreIcon: require('../assets/menu/icon_more.svg'),
            dataTh: ['Nama', 'Hari', 'Tanggal', 'Jadwal(In)', 'Checkin', 'Jadwal(Out)', 'Checkout', 'Status', 'Kantor(In)', 'Kantor(Out)', 'Jarak(In)', 'Jarak(Out)'],
            dataTd: [['nama', 'nik'], 'hari', 'tanggal', 'jamMasuk', 'jamKeluar', ['fotoMasuk', 'absenMasuk'], ['fotoKeluar', 'absenKeluar'], 'kantorMasuk', 'kantorKeluar', 'jarakMasuk', 'jarakKeluar', 'status'],
            styleTable: ['150px', '50px', '100px', '50px', '50px', '100px', '100px', '100px', '100px', '50px' , '50px' , '50px'],
            classReload: 'reloadOff',
            datas: [],

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchValue: '',
            dateStart: '',
            dateEnd: '',
            dataStatus: [],
            selectedStatus: {
                value: '',
                text: ''
            },


            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
        matchesTipePegawai() {
            if (this.queryTipePegawai == '') {
                return [];
            }
            return this.dataTipePegawai.filter((item) => item['text'].toLowerCase().includes(this.queryTipePegawai.toLowerCase()))
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        dateStart() {
            this.flagSearch = true
        },
        dateEnd() {
            this.flagSearch = true
        },
        queryPegawai() {
            this.getDataPegawai()
            this.flagSearch = true
        },
        queryUnit() {
            this.getDataUnit()
            this.flagSearch = true
        },
        queryTipePegawai() {
            this.flagSearch = true
            if(this.queryTipePegawai == '') {
                this.kodeTipePegawai = ''
            }
            this.getDataTipePegawai()
        },
        selectedStatus() {
            this.flagSearch = true
        }
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let nama = this.queryPegawai
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: nama,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].nik,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },
        //

        /**
         * SEARCH UNIT LEVEL
         */
        getDataUnit() {
            let unit = this.queryUnit
            let payload = {
                limit: 10,
                namaUnit: unit,
                pageIn: 1,
                namaParentUnit: '',
                idUnit: ''
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = ''
                    if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang
                        }                      
                    } else {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                        }
                    }
                    this.dataUnit.push(onPush)
                }
            })
        },
        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            this.visibleUnit = false;
            this.queryUnit = this.selectedItemUnit.text
            this.idUnits = this.selectedItemUnit.value
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },
        

        /**
         * SEARCH TIPE PEGAWAI
         */
        getDataTipePegawai() {
            let payload = {
                keterangan: this.queryTipePegawai,
                limit: 10,
                pageIn: 1
            }
            DataApi.post("pegawai/status/lihat", payload)
            .then(res => {
                this.dataTipePegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].kode,
                        text: tempData[i].keterangan
                    }
                    this.dataTipePegawai.push(onPush)
                }
            })
        },
        toggleVisibleTipePegawai() {
            this.visibleTipePegawai = true;
        },
        hideTipePegawai() {
            this.visibleTipePegawai = false;
        },
        toggleCloseVisibleTipePegawai() {
            setTimeout(this.hideTipePegawai, 1000);
        },
        itemClickedTipePegawai(index) {
            this.selectedTipePegawai = index;
            this.selectItemTipePegawai();
        },
        itemClickedTipePegawaiBefore(index) {
            this.selectedTipePegawai = index;
            this.selectedItemTipePegawai = this.dataTipePegawai[this.selectedTipePegawai];
            this.kodeTipePegawai = this.selectedItemTipePegawai.value
            this.queryTipePegawai = this.selectedItemTipePegawai.text
            this.visibleTipePegawai = false;
        },
        selectItemTipePegawai() {
            if (!this.matchesTipePegawai.length) {
            return;
            }
            this.selectedItemTipePegawai = this.matchesTipePegawai[this.selectedTipePegawai];
            this.visibleTipePegawai = false;
            this.kodeTipePegawai = this.selectedItemTipePegawai.value
            this.queryTipePegawai = this.selectedItemTipePegawai.text
            if (this.shouldReset) {
            this.queryTipePegawai = '';
            this.selectedTipePegawai = 0;
            }
        },
        upTipePegawai() {
            if (this.selectedTipePegawai == 0) {
            return;
            }
            this.selectedTipePegawai -= 1;
            this.scrollToItemTipePegawai();
        },
        downTipePegawai() {
            if (this.selectedTipePegawai >= this.matchesTipePegawai.length - 1) {
            return;
            }
            this.selectedTipePegawai += 1;
            this.scrollToItemTipePegawai();
        },
        scrollToItemTipePegawai() {
            this.$refs.optionsList.scrollTop = this.selectedTipePegawai * this.itemHeight;
        },

        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.hari.toLowerCase() < b.hari.toLowerCase()) {
                        return -1
                    }
                    if (a.hari.toLowerCase() > b.hari.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.jamMasuk.toLowerCase() < b.jamMasuk.toLowerCase()) {
                        return -1
                    }
                    if (a.jamMasuk.toLowerCase() > b.jamMasuk.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.jamKeluar.toLowerCase() < b.jamKeluar.toLowerCase()) {
                        return -1
                    }
                    if (a.jamKeluar.toLowerCase() > b.jamKeluar.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.absenMasuk.toLowerCase() < b.absenMasuk.toLowerCase()) {
                        return -1
                    }
                    if (a.absenMasuk.toLowerCase() > b.absenMasuk.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.absenKeluar.toLowerCase() < b.absenKeluar.toLowerCase()) {
                        return -1
                    }
                    if (a.absenKeluar.toLowerCase() > b.absenKeluar.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 7) {
                function compare(a,b) {
                    if (a.kantorMasuk.toLowerCase() < b.kantorMasuk.toLowerCase()) {
                        return -1
                    }
                    if (a.kantorMasuk.toLowerCase() > b.kantorMasuk.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 8) {
                function compare(a,b) {
                    if (a.kantorKeluar.toLowerCase() < b.kantorKeluar.toLowerCase()) {
                        return -1
                    }
                    if (a.kantorKeluar.toLowerCase() > b.kantorKeluar.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 9) {
                function compare(a,b) {
                    if (a.jarakMasuk.toLowerCase() < b.jarakMasuk.toLowerCase()) {
                        return -1
                    }
                    if (a.jarakMasuk.toLowerCase() > b.jarakMasuk.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 10) {
                function compare(a,b) {
                    if (a.jarakKeluar.toLowerCase() < b.jarakKeluar.toLowerCase()) {
                        return -1
                    }
                    if (a.jarakKeluar.toLowerCase() > b.jarakKeluar.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }  else if(value == 11) {
                function compare(a,b) {
                    if (a.status.toLowerCase() < b.status.toLowerCase()) {
                        return -1
                    }
                    if (a.status.toLowerCase() > b.status.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDownload() {
            this.$store.state.loadingScreen = true
            let pegawai = ''
            let niks = ''
            if(this.queryPegawai != '') {
                pegawai = this.queryPegawai.split(" - ")[0]
                niks = this.queryPegawai.split(" - ")[1]
            } else {
                pegawai = ''
                niks = ''
            }

            let unit = ''
            if(this.queryUnit != '') {
                unit = this.idUnits
            } else {
                unit = ''
            }
            
            let limit = this.totalRow
            let nama = pegawai
            let nik = niks

            let start = this.dateStart
            let end = this.dateEnd
            let tanggalMulai = ''
            let tanggalSelesai = ''
            if(start == '' && end == '') {
                let currentDate = new Date()
                let firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                let lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
                tanggalMulai = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate()
                tanggalSelesai = lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate()
            } else if(start == '' && end != '') {
                let myPastDate = new Date(end);
                myPastDate.setDate(myPastDate.getDate() - 30)
                tanggalMulai = myPastDate.getFullYear() + '-' + (myPastDate.getMonth() + 1) + '-' + myPastDate.getDate()
                tanggalSelesai = end
            } else if(start != '' && end == '') {
                let myFutureDate = new Date(start);
                myFutureDate.setDate(myFutureDate.getDate() + 30)
                tanggalMulai = start
                tanggalSelesai = myFutureDate.getFullYear() + '-' + (myFutureDate.getMonth() + 1) + '-' + myFutureDate.getDate()
            } else if(start != '' && end != '') {
                tanggalMulai = start
                tanggalSelesai = end
            }

            let status = this.selectedStatus.value

            let page = 1

            let payload = {
                nik: nik,
                limit: limit,
                nama: nama,
                pageIn: page,
                tanggalMulai: tanggalMulai,
                tanggalSelesai: tanggalSelesai,
                tipePegawai: this.kodeTipePegawai,
                unitLevel: unit,
                status: status
            }
            DataApi.post("absensi/backoffice/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.data
                    let data = [
                        {
                            sheet: 'Kedisiplinan Pegawai',
                            columns: [
                                { label: 'Nama', value: 'nama'  },
                                { label: 'NIP', value: 'nik' },
                                { label: 'Hari', value: 'hari' },
                                { label: 'Tanggal', value: 'tanggal' },
                                { label: 'Status', value: 'status' },
                                { label: 'Jadwal Jam Masuk', value: 'jamMasuk'},
                                { label: 'Jadwal Jam Keluar', value: 'jamKeluar'},
                                { label: 'Absen Masuk', value: 'absenMasuk'},
                                { label: 'Absen Keluar', value: 'absenKeluar'},
                                { label: 'Lama Bekerja(menit)', value: 'lamaKerja'},
                                { label: 'Jarak Masuk', value: 'jarakMasuk'},
                                { label: 'Jarak Keluar', value: 'jarakKeluar'},
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: 'Kedisiplinan Pegawai'
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let pegawai = ''
            let niks = ''
            if(this.queryPegawai != '') {
                pegawai = this.queryPegawai.split(" - ")[0]
                niks = this.queryPegawai.split(" - ")[1]
            } else {
                pegawai = ''
                niks = ''
            }

            let unit = ''
            if(this.queryUnit != '') {
                unit = this.idUnits
            } else {
                unit = ''
            }
            
            let limit = this.size
            let nama = pegawai
            let nik = niks

            let start = this.dateStart
            let end = this.dateEnd
            let tanggalMulai = ''
            let tanggalSelesai = ''
            if(start == '' && end == '') {
                let currentDate = new Date()
                let firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                let lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
                tanggalMulai = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate()
                tanggalSelesai = lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate()
            } else if(start == '' && end != '') {
                let myPastDate = new Date(end);
                myPastDate.setDate(myPastDate.getDate() - 30)
                tanggalMulai = myPastDate.getFullYear() + '-' + (myPastDate.getMonth() + 1) + '-' + myPastDate.getDate()
                tanggalSelesai = end
            } else if(start != '' && end == '') {
                let myFutureDate = new Date(start);
                myFutureDate.setDate(myFutureDate.getDate() + 30)
                tanggalMulai = start
                tanggalSelesai = myFutureDate.getFullYear() + '-' + (myFutureDate.getMonth() + 1) + '-' + myFutureDate.getDate()
            } else if(start != '' && end != '') {
                tanggalMulai = start
                tanggalSelesai = end
            }

            let status = this.selectedStatus.value

            let page = this.page

            let payload = {
                nik: nik,
                limit: limit,
                nama: nama,
                pageIn: page,
                tanggalMulai: tanggalMulai,
                tanggalSelesai: tanggalSelesai,
                tipePegawai: this.kodeTipePegawai,
                unitLevel: unit,
                status: status
            }
            DataApi.post("absensi/backoffice/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.queryPegawai = ''
            this.queryUnit = ''
            this.idUnits = ''

            this.dateStart = ''
            this.dateEnd = ''
            this.queryTipePegawai = ''
            this.kodeTipePegawai = ''
            this.selectedStatus.value = ''
            this.selectedStatus.text = ''
            this.getDataTipePegawai()
            this.getDataStatus()
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        getDataStatus() {
            this.dataStatus = [
                { value: '', text: 'All' },
                { value: '1', text: 'WFO' },
                { value: '0', text: 'WFH' },
                { value: '3', text: 'WFA' },
            ]
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
        this.getDataTipePegawai()
        this.getDataUnit()
        this.getDataStatus()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:52%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:47%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:42%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:37%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:32%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:57%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>